import {
  actualizarCargaGI,
  crearCargaGI,
  eliminarCargaGI,
  getCargasGI,
} from 'api/cargasGrupoInteres'
import { CARPETA_GRUPO_INTERES } from 'components/ModalCargarDatos/constants'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'
import { sanitizeFilename } from 'utils/archivos'

// @hooks
import { useSubirArchivo } from 'utils/aws'

const key = 'cargasGI'
export function useObtenerCargaGI(buscar) {
  return useQuery(key, () => getCargasGI(buscar))
}

export function useCrearCargaGI() {
  const queryClient = useQueryClient()
  return useMutation(crearCargaGI, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarCargaGI() {
  const queryClient = useQueryClient()
  return useMutation(actualizarCargaGI, {
    onSuccess: (_, value) => {
      const { id, values: cargaGIActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((cargaGI) => {
          let nuevoCargaGI = cargaGI
          if (id === cargaGI.id) {
            nuevoCargaGI = cargaGIActualizado
          }
          return nuevoCargaGI
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarCargaGI() {
  const queryClient = useQueryClient()
  return useMutation(eliminarCargaGI, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (cargaGI) => cargaGI.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useCargaGI(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarCargaGI } = useEliminarCargaGI()
  const { mutateAsync: actualizarCargaGI } = useActualizarCargaGI()
  const { mutateAsync: crearCargaGI } = useCrearCargaGI()
  const [subirArchivo] = useSubirArchivo()

  const handleCrearCargaGI = async ({archivo, ...values}, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearCargaGI({url_archivo: 'pendiente...' ,...values});
      const path = [CARPETA_GRUPO_INTERES, data.id].join('/');
      const fileName = sanitizeFilename(archivo.name)
      const { error } = await subirArchivo(archivo, path)
      if (error) {
        // eslint-disable-next-line
        throw ({archivo: [error.message]})
      }

      data.url_archivo = [path, fileName].join('/')
      await actualizarCargaGI({
        id: data.id,
        values: data,
      })
      
      const message = `La carga ${data.id} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarCargaGI = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarCargaGI({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La carga fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarCargaGI = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminala!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarCargaGI(id)
          const message = `La carga ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarCargaGI = async (value) => {
    queryClient.prefetchQuery(key, () => getCargasGI(value))
  }

  return {
    obtenerCargasGI: useObtenerCargaGI,
    handleEliminarCargaGI,
    handleActualizarCargaGI,
    handleCrearCargaGI,
    handleBuscarCargaGI,
  }
}
